// extracted by mini-css-extract-plugin
export default {"icon":"Step-module__icon__fT8w0","incomplete":"Step-module__incomplete__h6Ryf"};